import { LoadingSpinner } from "@components/layouts/LoadingSpinner";
import { selectCurrentToken } from "@states/auth/auth.slice";
import { Suspense } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import RootPage from "./RootPage";
import Cookies from "js-cookie";

const RequireAuth = () => {
  const token = Cookies.get("token");
  const user_id = Cookies.get("user_id");
  const storedToken = localStorage.getItem("dms-access-token");
  const location = useLocation();

  return token ? (
    // return true ? (
    <Suspense fallback={<LoadingSpinner />}>
      <RootPage />
    </Suspense>
  ) : (
    // Redirect to external URL
    // Staging
    // (window.location.href = "https://ssostaging.edkamm.com/login")
    // Production
    (window.location.href = "https://sso.edkamm.com/login")
  );
};

export default RequireAuth;
